// Async plugin — Nuxt 2 will wait for this to resolve before mounting the app.
// This guarantees the profile (and its permissions) are loaded before any page renders.
export default async ({ store, redirect }) => {
  const token = store.state.authProfile.token

  if (!token) {
    store.commit('authProfile/SET_PERMISSIONS_LOADED', true)
    return
  }

  try {
    await store.dispatch('authProfile/loadProfile')
  } catch {
    // Invalid / expired token — send to login, reset will happen via 401 interceptor
    store.dispatch('authProfile/reset')
    redirect('/auth/login')
  } finally {
    store.commit('authProfile/SET_PERMISSIONS_LOADED', true)
  }
}
